<div class="overlay--loading" *ngIf="!loaded"></div>

<header class="header--well" *ngIf="hasTitle">
    <ul>
        <li class="header__title">
            <h2>Title Information <small>{{titleViewType}}</small></h2>
        </li>
        <li>
            <ul class="list--views">
                <li>
                    <a class="list__link" href="javascript:void(0);" (click)="viewService.showDetail()">View AZ MVD Now Customer</a>
                </li>
            </ul>
        </li>
    </ul>
</header>

<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<div class="well" *ngIf="hasTitle">
    <div class="row">
        <div class="col-md-7 col-lg-6 mvd_form-group" [ngClass]="{'mvd_alert--message__warning': !canTransfer, 'mvd_alert--message__info':canTransfer}">
            <i class="material-icons"></i><h2 *ngIf="!canTransfer">Warning</h2>
            <div [innerHtml]="titleMessage | safeHtml"></div>
        </div>
    </div>

    <h2>Title Details</h2>
    <fieldset>
        <div class="row">
            <div class="col-md-6 mvd_form-group">
                <label>Vehicle</label>
                <div class="mvd_form-control">{{title.vehicleYear}} {{title.make}} {{title.model}}</div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>VIN</label>
                <div class="mvd_form-control">{{title.vin}}</div>
            </div>

            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Body Style</label>
                <div class="mvd_form-control">{{title.bodyStyle}}</div>
            </div>

            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Fuel Type</label>
                <div class="mvd_form-control">{{title.fuelType}}</div>
            </div>

            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Factory List Price</label>
                <div class="mvd_form-control">{{title.factoryListPrice | currency:'USD':'symbol-narrow'}}</div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Title Number</label>
                <div class="mvd_form-control">{{title.titleNumber}}</div>
            </div>
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Issue Date</label>
                <div class="mvd_form-control">{{title.titleIssueDateFormatted}}</div>
            </div>

            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Odometer Reading</label>
                <div class="mvd_form-control">{{title.odometerReading}} {{title.odometerReadingUnitType}}</div>
            </div>

            <div class="col-sm-4 mvd_form-group">
                <label>Odometer Code</label>
                <div class="mvd_form-control">{{title.odometerReadingType}}</div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Previous Title Number</label>
                <div class="mvd_form-control">{{title.previousTitleNumber}}</div>
            </div>

            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Previous Title State</label>
                <div class="mvd_form-control">{{title.previousTitleState}}</div>
            </div>

            <div class="col-sm-6 col-md-3 mvd_form-group">
                <label>Previous Issue Date</label>
                <div class="mvd_form-control">{{title.previousTitleIssueDate}}</div>
            </div>

        </div>
        <div class="row">
            <div class="col-sm-6 mvd_form-group">
                <label>Primary Owners</label>
                <ng-container *ngFor="let owner of title.ownerInformation;let i = index;">
                    <div class="mvd_form-control">
                        <div>{{owner.customerLegalName}}</div>
                        <ng-container *ngIf="owner.addressLine1">
                            <div>{{owner.addressLine1}}</div>
                            <div>{{owner.addressLine2}}</div>
                            <div>{{owner.city}}, {{owner.state}} {{owner.zipCode}}</div>
                        </ng-container>
                    </div>
                    <div class="mvd_form-control--boxless" *ngIf="i < title.ownerInformation.length-1">
                        <strong>&nbsp;{{owner.legalStatusType}}</strong>
                    </div>
                </ng-container>
            </div>
        </div>
    </fieldset>

    <h2>Title Status</h2>
    <fieldset>
        <div class="row">
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Lien</label>
                <div [ngClass]="{'mvd_alert--message__warning': hasLiens, 'mvd_alert--message__info':!hasLiens}"><i class="material-icons"></i>{{lienMessage}}</div>
                <br />
                <div class="mvd_form-control" *ngFor="let lien of title.lienInformation">
                    <div><b>{{lien.customerLegalName}}</b></div>
                    <div>{{lien.addressLine1}}</div>
                    <div>{{lien.addressLine2}}</div>
                    <div>{{lien.city}}, {{lien.state}} {{lien.zipCode}}</div>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Brand</label>
                <div [ngClass]="{'mvd_alert--message__warning': hasBrands, 'mvd_alert--message__info':!hasBrands}"><i class="material-icons"></i>{{brandMessage}}</div>
                <div class="title--brand" *ngFor="let brand of title.brands">
                    {{brand.name}} <ng-container *ngIf="brand.jurisdiction">({{brand.jurisdiction}})</ng-container>
                </div>
            </div>
            <div class="col-sm-6 col-md-4 mvd_form-group">
                <label>Last Updated</label>
                <div class="mvd_form-control">{{title.titleGoodAsOf | date :'shortDate'}} at {{title.titleGoodAsOf | date :'shortTime'}}</div>
            </div>
        </div>
    </fieldset>
</div>
